import React, {ChangeEvent, useCallback, useState} from 'react';
import {useTranslation} from 'react-i18next';

import {Dialog, Layout} from '@phonectas/unifon-ui-kit';
import TextDivWithLabelEditable from 'common/components/TextDivWithLabelEditable';
import useBmoStore from 'common/stores/bmoStore';
import {BmoNoteResponse} from 'common/types/store/bmoTypes';

interface EditNoteDialogProps {
	show: boolean;
	onClose: () => void;
	// onOk: () => void;
	caseId: string;
	note: BmoNoteResponse;
}

const EditNoteDialog: React.FC<EditNoteDialogProps> = ({show, onClose, note, caseId}) => {
	const [t] = useTranslation();
	const updateNote = useBmoStore((state) => state.updateNote);
	const getTicketId = useBmoStore((state) => state.getTicketId);
	const [text, setText] = useState(note?.text || '');
	const handleClose = useCallback(() => {
		onClose();
	}, [onClose]);
	const handleNoteChange = useCallback(
		(event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
			setText(event.target.value);
		}, []);
	const onUpdateNote = useCallback(async () => {
		if (!note?.id) return;
		try {
			await updateNote(caseId, note?.id, text, () => {
				onClose();
				getTicketId(caseId);
			});
		} catch (error) {
			console.error(error);
		}
	}, [caseId, note, text, onClose, updateNote, getTicketId]);

	return (
		<Dialog
			title={t('Edit note {{id}}', {id: note?.id})}
			show={show}
			onOk={onUpdateNote}
			okButtonLabel={t('Update')}
			onClose={handleClose}
			closeButtonLabel={t('Close')}
		>
			<Layout fullWidth>
				<TextDivWithLabelEditable
					text={text}
					onEdit={handleNoteChange}
				/>
			</Layout>
		</Dialog>
	);
}

export default EditNoteDialog;
